import { createAction } from '@reduxjs/toolkit';

export const addLoadingProducts = createAction<number | undefined>('products/addLoadingProducts');
